import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw, Mail } from "lucide-react";
import { useApi, useFetch, errMsg } from "../lib/api";
import { Button } from "./ui/button";

export const BriefingActions = ({ eid, onRegenerate, kind = "briefing", canSend = true }) => {
  const pe = kind === "briefing";
  const api = useApi();
  const { data: history, reload } = useFetch(`/email-preview/${kind}/${eid}/history`);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!window.confirm(pe ? "Send this week's briefing to the principal employer's approvers and compliance inbox now?" : "Send this week's to-do list to the contractor now?")) return;
    setBusy(true);
    try { const r = await api.post(`/email-preview/${kind}/${eid}/send`); toast.success(`Sent to ${r.data.sent} recipient(s)`); reload(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="grid gap-2 border-t border-[#1F2A3E] pt-4" data-testid="briefing-actions">
      <p className="text-[11px] text-slate-500">{pe ? "Goes out automatically every Monday at 9 am India time." : "Goes out every Monday at 9 am India time, only to contractors with something to fix."} The preview is written once a week; regenerate to use the latest data.</p>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="border-[#1F2A3E] hover:bg-[#1A2234]" onClick={onRegenerate} data-testid="briefing-regenerate-btn"><RefreshCw size={13} className="mr-1" />Regenerate</Button>
        <Button size="sm" variant="outline" className="border-[#00E599]/30 text-[#00E599] hover:bg-[#00E599]/10" disabled={busy || !canSend} onClick={send} data-testid="briefing-send-pe-btn">
          <Mail size={13} className="mr-1" />{busy ? "Sending…" : pe ? "Send to PE now" : "Send to contractor now"}</Button>
      </div>
      {!!history?.length && <div className="text-[11px] text-slate-400 grid gap-0.5" data-testid="briefing-history">
        <span className="text-slate-500">Recently sent</span>
        {history.slice(0, 5).map((h) => <span key={h.id}>{new Date(h.at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })} · {h.source === "cron" ? "Weekly" : "Manual"} · {h.nothing ? "nothing to fix" : `${h.sent} of ${h.to.length} sent`}{h.note ? ` · ${h.note}` : ""}</span>)}
      </div>}
    </div>);
};
